module.exports = __webpack_public_path__ + "img/randy_wayne.bd3cb20a.jpg";